<!--
 * @Description: 
 * @Autor: lwq
 * @Date: 2020-08-18 11:56:30
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2020-12-22 10:16:26
 * @FilePath: \mrc-ess-base-frontend\src\views\forget-password\module\confirm.vue
-->
<template>
  <transition name="fade">
    <v-overlay :value="dialog" :dark="false" @click="action(false)">
      <v-card :style="{
        width: screenSize > 750 ? '600px' : '80vw',
        height: screenSize > 750 ? '242px' : '250px',
        borderRadius: screenSize > 750 ? '4px' : '14px',
        minWidth: '245px',
      }">
        <v-card-title class="pa-8 forgetTitle" :style="{
          padding: screenSize > 750 ? '32px' : '16px !important',
          fontSize: screenSize > 750 ? '24px' : '5.5vw !important',
        }">
          {{ $t('label_pleaseCheckMailBox') }}
        </v-card-title>

        <v-card-text class="px-8 pb-8" style="text-align:left;color: #000000" :style="{
          padding: screenSize > 750 ? '32px' : '16px !important',
          paddingTop: 0,
        }">
          {{ msg || `${$t('label_forgotPasswordSendMailboxTips')} ${email || ''}` }}<br />
        </v-card-text>

        <v-card-actions class="pa-0 justify-end mr-8">
          <v-btn class="text-capitalize" color="primary" text :loading="loading" @click="action(false)">{{
            screenSize > 750 ? $t('label_resendEmail') : $t('label_cancel')
          }}</v-btn>
          <v-btn class="text-capitalize" color="primary" text @click="action(true)">{{
            screenSize > 750 ? $t('label_backToLogin') : $t('label_submit')
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-overlay>
  </transition>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
export default {
  components: {},
  props: {
    dialog: false,
    loading: {
      type: Boolean,
      default: false,
    },
    email: {
      type: String,
    },
    msg: {
      type: String,
    },
  },
  data() {
    return {
      screenSize: '',
      webPc: true,
    }
  },
  model: {
    prop: 'dialog',
    event: 'flag',
  },
  validations: {},
  computed: {},
  created() {
    const that = this
    that.screenSize = document.documentElement.clientWidth
    if (that.screenSize > 750) {
      that.webPc = true
    } else {
      that.webPc = false
    }
    this.resize(function () {
      that.screenSize = document.documentElement.clientWidth
      if (that.screenSize > 750) {
        that.webPc = true
      } else {
        that.webPc = false
      }
    })
  },
  watch: {},
  mounted() { },

  methods: {
    action(status) {
      if (status) {
        this.$emit('success')
        this.$emit('flag', false)
      } else {
        this.$emit('cancel')
        this.$emit('flag', false)
      }
    },
    resize(fn) {
      window.addEventListener('resize', function () {
        fn()
      })
    },
  },
}
</script>

<style scoped>
.forgetTitle {
  color: #000000;
  font-family: var(--body-font-family);
  font-weight: regular;
  line-height: 1.29;
  letter-spacing: 0px;
  text-align: left;
}
</style>
